module.exports = __webpack_public_path__ + "99648679e4d4dbc135b33050d6f4b52c.png";